<template>
    <div class="application-form-preview" v-loading="loading">
        <div v-if="loadError" class="preview-empty">{{ loadError }}</div>
        <div v-else-if="myJobData.id" ref="printDom" id="printDom" class="preview-print-dom">
            <div class="print-main">
                <div class="print-mt">
                    <table class="job-t-table">
                        <tr>
                            <td width="10%">
                                <div class="print-mt-logo"><img src="../assets/logo.png" alt="" /></div>
                            </td>
                            <td class="print-mt-mid-cell">
                                <div class="print-mt-mid-t">
                                    <div class="print-mt-mid-title">报名表</div>
                                    <div class="print-mt-mid-major" :class="printPositionNameSizeClass">{{ displayPositionsName }}</div>
                                </div>
                            </td>
                            <td width="28%" class="print-mt-right-cell">
                                <div class="print-mt-rl">
                                    <!-- <div class="print-mt-rlm">NO. {{ myJobData.creator_id }}</div> -->
                                    <div class="print-mt-rlb" v-if="myJobData.approval_status === 3">
                                        <i class="el-icon-check"></i> 资格审查通过
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
                <div class="print-msubt clearfix">
                    <div class="print-msubt-l">
                        <div class="print-msubt-lw"><B>填报时间：</B>{{ myJobData.created_at }}</div>
                    </div>
                    <div class="print-msubt-r">
                        <div class="print-msubt-lw"><B>填写方式：</B>{{ fileMethod[myJobData.fill_method] || '—' }}</div>
                    </div>
                </div>
                <div class="print-mm">
                    <table class="print-mtable">
                        <tr>
                            <td class="t1" colspan="9"><i class="el-icon-document tdIcon"></i> 填写内容 (基本资料)</td>
                        </tr>
                        <tr>
                            <td width="20%" class="t2">姓&emsp;&emsp;名</td>
                            <td width="20%" colspan="2" class="lw">{{ myJobData.name }}</td>
                            <td width="20%" colspan="3" class="t2">性&emsp;&emsp;别</td>
                            <td width="20%" colspan="2" class="lw">{{ {0:'女',1:'男',2:'其他'}[myJobData.gender] }}</td>
                            <td width="20%" rowspan="5">
                                <img class="print-avatar" v-if="myJobData.photo_url" :src="myJobData.photo_url" alt="" />
                                <img class="print-avatar" v-else src="../assets/images/defaultPhoto.jpeg" alt="" />
                            </td>
                        </tr>
                        <tr>
                            <td class="t2">手  机  号</td>
                            <td colspan="2" class="lw">{{ myJobData.phone }}</td>
                            <td colspan="3" class="t2">政治面貌</td>
                            <td colspan="2" class="lw">{{ zzmm[myJobData.political_status] }}</td>
                        </tr>
                        <tr>
                            <td class="t2">身份证号</td>
                            <td colspan="7" class="lw">{{ myJobData.id_card_number }}</td>
                        </tr>
                        <tr>
                            <td class="t2">常住地址</td>
                            <td colspan="7" class="lw">{{ displayResidentAddress }}</td>
                        </tr>
                        <tr>
                            <td class="t2">籍&emsp;&emsp;贯</td>
                            <td colspan="7" class="lw">{{ displayNativePlace }}</td>
                        </tr>
                        <tr>
                            <td class="t2">应聘专业</td>
                            <td colspan="8" class="lw">{{ displayPositionsName }}</td>
                        </tr>
                        <tr>
                            <td class="t2">最高学历</td>
                            <td colspan="8" class="lw">{{ displayHighestEducation }}</td>
                        </tr>
                        <tr>
                            <td class="t2">邮&emsp;&emsp;箱</td>
                            <td colspan="8" class="lw">{{ myJobData.email }}</td>
                        </tr>
                        <tr>
                            <td width="28%" colspan="2" :rowspan="myJobData.familyNum" class="t2">家庭成员</td>
                            <td width="18%" colspan="2" class="t2">成员关系</td>
                            <td width="18%" colspan="2" class="t2">姓名</td>
                            <td width="18%" colspan="2" class="t2">手机号</td>
                            <td width="18%" class="t2">工作单位</td>
                        </tr>
                        <tr v-for="(item, index) in familyList" :key="'fam-' + index">
                            <td colspan="2">{{ relationType[item.relationType] }}</td>
                            <td colspan="2">{{ item.name }}</td>
                            <td colspan="2">{{ item.mobile }}</td>
                            <td>{{ item.workUnit || item.work_unit || '—' }}</td>
                        </tr>
                        <tr>
                            <td class="t1" colspan="9"><i class="el-icon-medal tdIcon"></i> 学历信息 & 附件</td>
                        </tr>
                        <template v-for="(edu, eduIdx) in printEducationSegments">
                            <tr :key="'edu-h-' + eduIdx">
                                <td class="t1 print-edu-seg-title" colspan="9">{{ edu.segmentTitle }}</td>
                            </tr>
                            <tr :key="'edu-1-' + eduIdx">
                                <td colspan="2" class="t2">学&emsp;&emsp;校</td>
                                <td colspan="3" class="lw">{{ edu.graduatedInstitution || '—' }}</td>
                                <td colspan="2" class="t2">学科/专业</td>
                                <td colspan="2" class="lw">{{ edu.major || '—' }}</td>
                            </tr>
                            <tr v-if="edu.majorCode" :key="'edu-code-' + eduIdx">
                                <td colspan="2" class="t2">专业代码</td>
                                <td colspan="7" class="lw">{{ edu.majorCode }}</td>
                            </tr>
                            <tr :key="'edu-2-' + eduIdx">
                                <td colspan="2" class="t2">学&emsp;&emsp;历</td>
                                <td colspan="3" class="lw">{{ edu.educationLevel || '—' }}</td>
                                <td colspan="2" class="t2">毕业日期</td>
                                <td colspan="2" class="lw">{{ edu.departureDate || '—' }}</td>
                            </tr>
                            <tr :key="'edu-3-' + eduIdx">
                                <td colspan="2" class="t2">国内院校</td>
                                <td colspan="3" class="lw">{{ edu.isDomesticText || '—' }}</td>
                                <td v-if="edu.isDomesticYes" colspan="2" class="t2">{{ edu.institutionLabel }}</td>
                                <td v-if="edu.isDomesticYes" colspan="2" class="lw">{{ edu.institutionValue || '—' }}</td>
                                <td v-if="edu.isDomesticNo" colspan="2" class="t2">{{ edu.institutionLabel }}</td>
                                <td v-if="edu.isDomesticNo" colspan="2" class="lw">{{ edu.institutionValue || '—' }}</td>
                                <td v-if="!edu.isDomesticYes && !edu.isDomesticNo" colspan="4" class="lw">—</td>
                            </tr>
                            <tr :key="'edu-4-' + eduIdx">
                                <td colspan="2" class="t2">学信网学籍</td>
                                <td colspan="3" class="lw">{{ edu.attachXuexin }}</td>
                                <td colspan="2" class="t2">毕业证</td>
                                <td colspan="2" class="lw">{{ edu.attachGrad }}</td>
                            </tr>
                            <tr :key="'edu-5-' + eduIdx">
                                <td colspan="2" class="t2">学位证</td>
                                <td colspan="3" class="lw">{{ edu.attachDegree }}</td>
                                <template v-if="edu.isDomesticNo">
                                    <td colspan="2" class="t2">教育部留学服务中心认证</td>
                                    <td colspan="2" class="lw">{{ edu.attachStudyAbroad }}</td>
                                </template>
                                <template v-else>
                                    <td colspan="2" class="t2"></td>
                                    <td colspan="2" class="lw"></td>
                                </template>
                            </tr>
                        </template>
                        <tr>
                            <td colspan="9" class="t2">附件资料清单 (共 {{ personalAttachmentCount }} 项)</td>
                        </tr>
                        <tr>
                            <td colspan="2" class="t2">身份证正面</td>
                            <td colspan="3" class="lw">{{ upStatus.idFront }}</td>
                            <td colspan="2" class="t2">身份证反面</td>
                            <td colspan="2" class="lw">{{ upStatus.idBack }}</td>
                        </tr>
                        <tr>
                            <td colspan="2" class="t2">免冠照</td>
                            <td colspan="3" class="lw">{{ upStatus.photo }}</td>
                            <td colspan="2" class="t2">无犯罪记录证明</td>
                            <td colspan="2" class="lw">{{ upStatus.criminalRecord }}</td>
                        </tr>
                        <tr>
                            <td colspan="9" class="lw">
                                <div class="print-commitment">
                                    <div class="print-commitment-t"><i class="el-icon-success"></i> 承诺声明</div>
                                    <div class="print-commitment-b">本人承诺所填报的全部内容真实有效，按要求仅报考一个单位。若刻意隐瞒或遗漏任何影响公司作出正确判断的重大事项，本人愿承担全部责任。</div>
                                </div>
                                <div class="print-commitment-signb clearfix">
                                    <span class="print-commitment-signline"><img v-if="signImgSrc" :src="signImgSrc" alt="签名" /></span>
                                    <span class="print-commitment-signbtip">本人签字：</span>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
                <div class="print-mb">System Ref: 9482-ADFA-2291-L3796 | Page 1 of 1</div>
            </div>
            <div style="page-break-after: always;"></div>
            <div class="print-main">
                <div class="bm-file-tle">
                    <el-divider><span style="font-size: 24px;">附件详情</span></el-divider>
                </div>
                <div v-for="item in allAttachmentPreviewList" :key="item.key">
                    <div class="bm-file-p">
                        <attachment-preview-item :url="item.url" />
                    </div>
                    <div class="bm-file-name">{{ item.label }}</div>
                </div>
                <div v-if="!allAttachmentPreviewList.length" class="preview-no-attach">暂无附件</div>
            </div>
        </div>
    </div>
</template>

<script>
import applicationFormPreviewMixin from '../mixins/applicationFormPreviewMixin';
import AttachmentPreviewItem from './AttachmentPreviewItem.vue';

export default {
    name: 'ApplicationFormPreview',
    mixins: [applicationFormPreviewMixin],
    components: { AttachmentPreviewItem },
    props: {
        applicationId: {
            type: [Number, String],
            required: true,
        },
    },
    watch: {
        applicationId: {
            immediate: true,
            handler(val) {
                if (val != null && val !== '') {
                    this.loadApplicationPreview(val);
                }
            },
        },
    },
};
</script>

<style scoped>
.application-form-preview{min-height: 120px;}
.preview-empty{padding: 48px; text-align: center; color: #6A7282; font-size: 16px;}
.preview-no-attach{padding: 24px; text-align: center; color: #99A1AF;}
.preview-print-dom{width: 794px; max-width: 100%; margin: 0 auto;}
.print-main{padding: 30px 60px; background: #fff;}
.print-mt{height: 85px; border-bottom: 2px solid #E7000B;}
.job-t-table{width: 100%; border: none; border-collapse: collapse; border-spacing: 0;}
.job-t-table td{border: none;}
.print-mt-logo{width: 36px; height: 36px; padding: 6px; float: left;}
.print-mt-logo img{width: 36px; height: 36px; border: none;}
.print-mt-mid-cell{vertical-align: middle; padding-left: 16px;}
.print-mt-mid-t{display: flex; flex-direction: column; justify-content: center; max-width: 100%; min-height: 56px; font-family: Arial, "Microsoft YaHei", sans-serif;}
.print-mt-mid-title{color: #101828; font-size: 22px; font-weight: 900; line-height: 1.2; letter-spacing: 0.1em;}
.print-mt-mid-major{margin-top: 4px; color: #364153; font-size: 15px; font-weight: 700; line-height: 1.35; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;}
.print-mt-mid-major--md{font-size: 13px;}
.print-mt-mid-major--sm{font-size: 12px;}
.print-mt-mid-major--xs{font-size: 11px; line-height: 1.25;}
.print-mt-mid-major--wrap{white-space: normal; overflow: hidden; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; text-overflow: clip;}
.print-mt-right-cell{vertical-align: middle; text-align: right;}
.print-mt-rl{display: inline-block; padding-right: 4px; font-size: 12px; line-height: 22px; text-align: right;}
.print-mt-rlm{color: #101828; font-weight: bold;}
.print-mt-rlb{color: #00A63E;}
.print-msubt{padding: 24px 0 18px 0;}
.print-msubt-l{float: left;}
.print-msubt-lw{color: #4A5565; font-size: 14px; line-height: 22px;}
.print-msubt-lw B{color: #101828;}
.print-msubt-r{float: right; padding-top: 15px;}
.print-mm{padding-bottom: 18px;}
.print-mb{text-align: center; color: #99A1AF; font-size: 12px; line-height: 20px;}
.print-mtable{width: 100%; border-spacing: 0; border-collapse: collapse; border: 2px solid #99A1AF;}
.print-mtable td{border: 1px solid #D1D5DC; padding: 2px 8px; font-size: 12px; line-height: 20px; background: #fff; color: #1E2939; text-align: center;}
.print-mtable td.t1{background: #F3F4F6; text-align: left; font-size: 14px; color: #1E2939; font-weight: bold;}
.print-mtable td.print-edu-seg-title{background: #FAFAFA; font-size: 13px; color: #364153; padding-left: 28px;}
.print-mtable td.t2{background: #F9FAFB;}
.print-mtable td.lw{text-align: left;}
.tdIcon{font-size: 16px; color: #E7000B; margin-right: 10px;}
.print-avatar{width: 96px; height: 128px; border: 1px solid #E5E7EB;}
.print-commitment{padding: 8px 24px;}
.print-commitment-t{line-height: 30px; font-weight: bold; font-size: 14px;}
.print-commitment-b{padding-left: 24px; color: #4A5565;}
.print-commitment-signb{padding: 20px 32px 15px 0; text-align: right;}
.print-commitment-signbtip{float: right; line-height: 40px; font-weight: bold; color: #1E2939;}
.print-commitment-signline{width: 150px; height: 60px; float: right; line-height: 20px; font-weight: bold; color: #1E2939; border-bottom: 1px solid #333; text-align: center;}
.print-commitment-signline img{width: 150px; height: 55px;}
.bm-file-tle{padding-top: 10px;}
.bm-file-p{padding: 10px 0; text-align: center;}
.bm-file-name{font-size: 20px; text-align: center; padding: 30px 0;}
.clearfix:after,.clearfix:before{clear: both; content: ""; display: block; line-height: 0;}
</style>
